import React from 'react';
import Order from './Order';
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from 'react-i18next';
import { productionOrderStates as state } from '../../Config/productionOrderStates'
import PlayArrowRoundedIcon from '@material-ui/icons/PlayArrowRounded';
import PauseRoundedIcon from '@material-ui/icons/PauseRounded';
import Timer from '../Shared/Timer';
import { IconButton } from '@material-ui/core';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


export default function OrderColorDisplay(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    let showElapsed = props.productionOrder.productionOrderStatus === state.PAUSED || props.productionOrder.productionOrderStatus === state.RUNNING
    let stateIcon = <React.Fragment></React.Fragment>;
    switch (props.productionOrder.productionOrderStatus) {
        case state.RUNNING:
            stateIcon = <PlayArrowRoundedIcon className={classes.play}></PlayArrowRoundedIcon>;
            break;
        case state.PAUSED:
            stateIcon = <PauseRoundedIcon className={classes.pause} ></PauseRoundedIcon>;
            break;
        case state.STOPPED:
            stateIcon = <div className={classes.stop}></div>;
            break;
        case state.DONE:
            stateIcon = <img className={classes.done} alt="done" src={process.env.PUBLIC_URL + '/img/done.svg'}></img>
            break;
        case state.PLANNED:
            stateIcon = <img className={classes.planned} alt="planned" src={process.env.PUBLIC_URL + '/img/planned.svg'}></img>
            break;
        default:
    }

    return <div>
        <div className={classes.orderContainer} onClick={() => props.handleOpenColorDisplay(props.productionOrder.id)}>
            <div className={classes.coloredBorderLeft} style={{ backgroundColor: props.productionOrder.productionOrderStatusForegroundColor }}></div>
            <div className={classes.expandBox}>
                < IconButton>
                    {props.openColorDisplayNumber === props.productionOrder.id ? <ExpandLessIcon fontSize='large' /> : <ExpandMoreIcon fontSize='large' />}
                </IconButton>
            </div>

            <div className={classes.orderColorBox} style={{ backgroundColor: props.productionOrder.bomOut[0].colorCode, backgroundImage: props.productionOrder.bomOut[0].colorCode ? "" : "linear-gradient(45deg, #808080 25%, transparent 25%), linear-gradient(-45deg, #808080 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #808080 75%), linear-gradient(-45deg, transparent 75%, #808080 75%)" }}></div>

            <div className={classes.orderInfo}>
                <div className={classes.label}>
                    Ordern°
                </div>
                <div className={classes.info}>
                    <div className={classes.reference}>
                        {props.productionOrder.reference}
                    </div>
                </div>
            </div>

            <div className={classes.orderInfo}>
                <div className={classes.label}>
                    {t('Article')}
                </div>
                <div className={classes.info}>
                    <div className={classes.reference}>
                        {props.productionOrder.bomOut[0].productReference}
                    </div>
                </div>
            </div>

            <div className={classes.orderInfoWide35}>
                <div className={classes.label}>
                    {t('Description')}
                </div>
                <div className={classes.info}>
                    <div className={classes.reference}>
                        {props.productionOrder.bomOut[0].productDescription}
                    </div>
                </div>
            </div>

            <div className={classes.orderInfoWide15}>
                <div className={classes.label}>
                    {t("Client")}
                </div>
                <div className={classes.info}>
                    <div className={classes.reference}>
                        {props.productionOrder.customerName}
                    </div>
                </div>
            </div>

            <div className={classes.coloredBorderRight} style={{ backgroundColor: props.productionOrder.productionOrderStatusForegroundColor + '44', }}>
                <div className={classes.stateElapsed}>
                    <div className={classes.state} style={{ paddingTop: showElapsed ? "0px" : "3px" }}>{t(props.productionOrder.productionOrderStatus)}</div>
                    {showElapsed ?
                        <div className={classes.elapsed}><Timer startTime={props.productionOrder.startedOn} {...props}></Timer></div>
                        : <React.Fragment></React.Fragment>
                    }
                </div>
                <div className={classes.borderBar}></div>
                <div className={classes.iconContainer}>
                    <div className={classes.icon}>{stateIcon}</div>
                </div>
            </div>
        </div>
        {props.openColorDisplayNumber === props.productionOrder.id ?
            <div>
                <Order {...props}></Order>
            </div> : <React.Fragment></React.Fragment>
        }
    </div>

}

const useStyles = makeStyles({
    orderContainer: {
        backgroundColor: "white",
        borderRadius: "6px",
        boxShadow: "0px 3px 15px rgba(0,0,0,0.1)",
        display: 'flex',
        flexDirection: 'row',
        justifyContent: "flex-start",
        cursor: "pointer",
    },
    coloredBorderLeft: {
        width: "7px",
        borderRadius: "6px 0px 0px 6px",
        opacity: "0.28",
        display: 'flex',
        float: "left",
    },
    coloredBorderRight: {
        borderRadius: "6px 6px 6px 0px",
        display: 'flex',
        flexDirection: 'row',
        float: "right",
        marginLeft: "auto",
        justifyContent: "flex-end",
        width: "15%",
        maxWidth: "170px",
        overflow: "hidden",
    },
    expandBox: {
        width: '5%',
        maxWidth: '60px',
        display: 'flex',
        float: "left",
    },
    orderColorBox: {
        minWidth: '20px',
        maxWidth: '200px',
        width: '10%',
        Height: '100%',
        borderRadius: "6px",
        border: "3px solid #DEDEDE",
        margin: "10px",
        backgroundSize: "20px 20px",
        backgroundPosition: "0 0, 0 10px, 10px -10px, -10px 0px",
        boxShadow: "0px 3px 15px rgba(0,0,0,0.1)",
        display: 'flex',
    },
    iconContainer: {
        display: 'flex',
        float: "right",
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '28%',
    },
    icon: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px',
        width: '50px',
    },
    stateElapsed: {
        padding: '10px',
        width: '70%',
        minWidth: '80px',
        display: 'flex',
        float: "right",
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        overflow: "hidden",
    },
    state: {
        textTransform: "uppercase",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        display: "block",
        float: "right",
    },
    elapsed: {
        fontSize: '10px',
        opacity: '0.8'
    },
    borderBar: {
        marginTop: '5%',
        marginBottom: '5%',
        float: "right",
        maxWidth: '3px',
        width: '2%',
        backgroundColor: 'black',
        opacity: '0.28'
    },
    orderInfo: {
        boxSizing: "border-box",
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: '10%',
    },
    orderInfoWide15: {
        boxSizing: "border-box",
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: '15%',
        overflow: "hidden",
    },
    orderInfoWide35: {
        boxSizing: "border-box",
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: '35%',
    },
    reference: {
        float: "left",
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: "100%",
    },
    label: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        display: "block",
    },
    info: {
        color: "#020100",
        display: "block",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    done: {
        height: "35px",
        width: "35px",
    },
    play: {
        color: "#5CC958",
        height: "40px",
        width: "40px",
    },
    stop: {
        height: "35px",
        width: "35px",
        backgroundColor: "#D84949",
        borderRadius: "3px",
    },
    pause: {
        height: "35px",
        width: "35px",
        color: "#F59127",
    },
    planned: {
        height: "25px",
        width: "25px",
    },
});